import React, { AriaAttributes } from 'react';
import { generateIndexArray } from '../../../services/utils';

import { DealStoreCardSkeleton, SkeletonContainer } from './style';

export type StoreOffersTabSkeletonProps = {
  animate?: boolean;
  cardsLength: number;
} & AriaAttributes;

const StoreDealsTabSkeleton: React.FC<StoreOffersTabSkeletonProps> = ({
  animate,
  cardsLength,
  ...rest
}) => (
  <SkeletonContainer animate={animate} cardsLength={cardsLength} {...rest}>
    {generateIndexArray(cardsLength).map((index) => (
      <DealStoreCardSkeleton animate={animate} key={index} />
    ))}
  </SkeletonContainer>
);

export default StoreDealsTabSkeleton;
